import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  CanActivateChild,
  CanLoad,
  ActivatedRouteSnapshot,
  Route,
  UrlSegment,
} from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route?: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      map((authenticated: boolean) => {
        if (!authenticated) {
          this.authService.navigateToLogin(this.getUrlFromSegments(route.url));
          return false;
        }
        return true;
      }),
      catchError((err) => {
        this.authService.navigateToLogin();
        return Observable.throw(err);
      })
    );
  }

  private getUrlFromSegments(url: UrlSegment[]) {
    return url.reduce((path: UrlSegment, url: UrlSegment) => {
      path.path += '/' + url.path;
      return path;
    }, new UrlSegment('', {})).path;
  }

  canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.canActivate(route);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      map((authenticated: boolean) => {
        if (!authenticated) {
          this.authService.navigateToLogin(this.getUrlFromSegments(segments));
          return false;
        }
        return true;
      }),
      catchError((err) => {
        this.authService.navigateToLogin();
        return Observable.throw(err);
      })
    );
  }
}
